import { adminApiPost, generalApiPost } from './apiPost'

export const getUserPermissions = generalApiPost('get-user-permissions')

export const getAdminManagedUsers = adminApiPost('get-admin-managed-users')

export const getAdminManagedResources = adminApiPost('get-admin-managed-resources')

export const editManagePermission = adminApiPost('manage-permissions')

export const uploadUserInfo = adminApiPost('update-user-info')

export const setUserStatus = adminApiPost('set-user-active-status')

export const createUser = adminApiPost('create-new-user')

export const resetPassword = adminApiPost('reset-password')
